import * as React from "react"

const SidebarPopular = () => {

  return (
    <ul className="flex flex-col gap-y-3">
      <li className="flex space-x-3">
        <img className="w-24 border" src="https://storage.designup.jp/blog/vscode/vscode-best-themes-10.png" alt=""/>
        <a className="text-md font-bold text-black" href="./vscode-best-themes.html">2024 VSCodeのおすすめテーマはこれだ！</a>
      </li>
      <li className="flex space-x-3">
        <img className="w-24 border" src="https://storage.designup.jp/blog/figma/figma-convert-html-01.png" alt=""/>
        <a className="text-md font-bold text-black" href="./figma-convert-html.html">FigmaからHTML/CSSコードを生成する方法</a>
      </li>
      <li className="flex space-x-3">
        <img className="w-24 border" src="https://storage.designup.jp/blog/html/html-lineheight-01.png" alt=""/>
        <a className="text-md font-bold text-black" href="./html-lineheight.html">HTMLで行間を調整したりCSSを使わずに改行する方法</a>
      </li>
      <li className="flex space-x-3">
        <img className="w-24 border" src="https://storage.designup.jp/blog/css/css-scrollbar-00.png" alt=""/>
        <a className="text-md font-bold text-black" href="./css-scrollbar.html">スクロールバーのデザインと表示方法をカスタマイズ！CSS完全ガイド</a>
      </li>
      <li className="flex space-x-3">
        <img className="w-24 border" src="https://storage.designup.jp/blog/html/html-calendar-01.png" alt=""/>
        <a className="text-md font-bold text-black" href="./html-calendar.html">ホームページにカレンダーを実装！テンプレート付きで解説</a>
      </li>
      <li className="flex space-x-3">
        <img className="w-24 border" src="https://storage.designup.jp/blog/html/html-table-style-06.png" alt=""/>
        <a className="text-md font-bold text-black" href="./html-table-style.html">HTMLテーブルの枠線を一部にだけ付ける、消すなどの実装方法</a>
      </li>
    </ul>
  )
}

export default SidebarPopular